import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AdminLayout from "../../../src/component/admin/AdminLayout";

import { getRetreats } from "../../services/retreatService";
export default function Dashboard() {
  const navigate = useNavigate();

  const [retreats, setRetreats] = useState([]);

useEffect(() => {
  loadDashboard();
}, []);

const loadDashboard = async () => {
  try {
    const res = await getRetreats();
    setRetreats(res.data);
  } catch (err) {
    console.error(err);
  }
};

  const totalRetreats = retreats.length;

  const publishedRetreats = retreats.filter(
    (retreat) =>
      retreat.status?.toLowerCase() === "published"
  ).length;

  const draftRetreats = retreats.filter(
    (retreat) =>
      retreat.status?.toLowerCase() === "draft"
  ).length;

  return (
    <AdminLayout>
      <h1 className="text-4xl font-bold mb-8">
        Dashboard
      </h1>

<div className="grid md:grid-cols-5 gap-6">

  {/* Total Retreats */}
  <div
    onClick={() =>
      navigate("/admin/retreats?filter=all")
    }
    className="bg-white p-6 rounded-2xl shadow cursor-pointer hover:shadow-xl hover:-translate-y-1 transition-all"
  >
    <h3 className="text-gray-500">
      Total Retreats
    </h3>

    <p className="text-4xl font-bold mt-3">
      {totalRetreats}
    </p>
  </div>

  {/* Published */}
  <div
    onClick={() =>
      navigate(
        "/admin/retreats?filter=published"
      )
    }
    className="bg-white p-6 rounded-2xl shadow cursor-pointer hover:shadow-xl hover:-translate-y-1 transition-all"
  >
    <h3 className="text-gray-500">
      Published
    </h3>

    <p className="text-4xl font-bold mt-3 text-green-600">
      {publishedRetreats}
    </p>
  </div>

  {/* Drafts */}
  <div
    onClick={() =>
      navigate(
        "/admin/retreats?filter=draft"
      )
    }
    className="bg-white p-6 rounded-2xl shadow cursor-pointer hover:shadow-xl hover:-translate-y-1 transition-all"
  >
    <h3 className="text-gray-500">
      Drafts
    </h3>

    <p className="text-4xl font-bold mt-3 text-yellow-600">
      {draftRetreats}
    </p>
  </div>

  {/* Packages */}
  <div className="bg-white p-6 rounded-2xl shadow">
    <h3 className="text-gray-500">
      Total Packages
    </h3>

    <p className="text-4xl font-bold mt-3 text-blue-600">
      {retreats.reduce((total, retreat) => {
  if (Array.isArray(retreat.packages)) {
    return total + retreat.packages.length;
  }

  return total;
}, 0)}
    </p>
  </div>

  {/* Upcoming */}
  <div className="bg-white p-6 rounded-2xl shadow">
    <h3 className="text-gray-500">
      Upcoming Events
    </h3>

    <p className="text-4xl font-bold mt-3 text-purple-600">
      {
retreats.filter(
  (retreat) =>
    new Date(retreat.startDate) >
    new Date()
).length      }
    </p>
  </div>

</div>
    </AdminLayout>
  );
}